<template>
  <div class="no-records-card">
    <div class="no-records-card__icon">
      <v-icon
        size="40"
        color="#3A67B1"
      >
        {{ icon }}
      </v-icon>
    </div>
    <h3 class="no-records-card__title">
      {{ title }}
    </h3>
    <p
      v-if="text"
      class="no-records-card__text"
    >
      {{ text }}
    </p>
  </div>
</template>

<script>
export default {
  name: "NoRecordsCard",
  props: {
    icon: {
      type: String,
      default: "mdi-database-off-outline",
    },
    title: {
      type: String,
      default: "No Records Found",
    },
    text: {
      type: String,
      default: "There are no records to display right now.",
    },
  },
};
</script>

<style scoped lang="scss">
.no-records-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 100%;
  padding: 56px 24px;
  background: #ffffff;
  border: 1.5px dashed rgba(58, 103, 177, 0.3);
  border-radius: 16px;
  box-shadow: 0 4px 16px rgba(10, 15, 41, 0.05);

  &__icon {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 76px;
    height: 76px;
    border-radius: 50%;
    background: linear-gradient(135deg, #eef5ff 0%, #dbedff 100%);
    border: 1px solid rgba(58, 103, 177, 0.25);
    margin-bottom: 16px;
  }

  &__title {
    font-size: 18px;
    font-weight: 700;
    color: #0a0f29;
    margin: 0 0 6px;
  }

  &__text {
    font-size: 13.5px;
    color: #414042;
    max-width: 420px;
    margin: 0;
  }
}
</style>
